import { css } from '@emotion/react';

import colors from '../../../configs/colors';

export const iconStyles = css`
  font-size: 20px;
  color: ${colors.PRIMARY_BLACK};
`;
